import Component from '../Component';
import classList from '../utils/classList';
export default class Form extends Component {
  view(vnode) {
    const {
      label,
      description,
      className,
      ...attrs
    } = vnode.attrs;
    return m("div", Object.assign({
      className: classList('Form', className)
    }, attrs), (label || description) && m("div", {
      className: "Form-header"
    }, label && m("label", null, label), description && m("p", {
      className: "helpText"
    }, description)), m("div", {
      className: "Form-body"
    }, vnode.children));
  }
}
flarum.reg.add('core', 'common/components/Form', Form);